import { render, staticRenderFns } from "./Contests.vue?vue&type=template&id=280cf314&scoped=true&"
import script from "./Contests.vue?vue&type=script&lang=js&"
export * from "./Contests.vue?vue&type=script&lang=js&"
import style0 from "./Contests.vue?vue&type=style&index=0&id=280cf314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280cf314",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BContainer, BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BContainer, BCol, BRow})
    

export default component.exports